import {EmailAuthProvider, reauthenticateWithCredential, User, UserCredential} from "@firebase/auth";

export const reauthenticateWithEmail = (user: User, email: string, password: string) => {
  const credential = EmailAuthProvider.credential(email, password);
  return reauthenticateWithCredential(user, credential);
};

export const reauthenticate = (user: User, password: string): Promise<UserCredential> => {
  if (!user.email) {
    throw new Error("User email is missing");
  }
  return reauthenticateWithEmail(user, user.email, password);
}